import React from "react";
import { withGoogleApi } from "components"
import { compose, withProps } from "recompose"
import {  withGoogleMap, GoogleMap, Marker } from "react-google-maps"
import { useFormState, useForm } from 'react-final-form'

const enchance = compose(
  withProps({
    containerElement: <div style={{ height: `400px`, width: `400px` }} />,
    mapElement: <div style={{ height: `100%` }} />,
  }),
  withGoogleApi,
  withGoogleMap
)
const MapEdit = enchance(({zoom, source, enableDrag, onPositionChanged, lat, lng, ...props}) => {
  const {change} = useForm()
  const unmappedOnPositionChanged = pos => {
    const [lat, lng] = [pos.latLng.lat(), pos.latLng.lng()]
    change(`${source}.lat`, lat)
    change(`${source}.lng`, lng)
    onPositionChanged && onPositionChanged({lat, lng})
  }
  return <GoogleMap defaultZoom={zoom || 8} center={{lat, lng}} >
    <Marker position={{lat, lng}} draggable={(onPositionChanged || enableDrag) ? true : false}  onDragEnd={unmappedOnPositionChanged}/>
  </GoogleMap>
})
const MapView = enchance(({zoom, lat, lng, ...props}) => {
  return <GoogleMap defaultZoom={zoom || 8} center={{lat, lng}} >
    <Marker position={{lat, lng}} draggable={false}  />
  </GoogleMap>
})

export default ({viewMode, ...props}) => {
  if(viewMode) {
    const {lat, lng} = props.record[props.source] || {}
    return (lat && lng) ? <MapView lat={lat} lng={lng} {...props} /> : <span />
  } else {
    const {values} = useFormState()
    const {lat, lng} = values[props.source] || {}
    return (lat && lng) ? <MapEdit lat={lat} lng={lng} {...props} /> : <span />
  }

}
